import classNames from "classnames";
import style from "./DrugIndicationList.module.scss";
import { createUrlFromDitaFilename } from "../../utils/formatters/createUrlFromDitaFilename";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { extractDrugClassFromFilename } from "../../utils/formatters/extractDrugClassFromFilename";

const DrugExtraInformation = ({
  pregnancyInfo,
  pregnancyInfoNote,
  pregnancyInfoDescription,
  breastfeedingCategory,
  breastfeedingDescription,
  breastfeedingNote,
  renalAdjustmentsHref,
  showCalculator,
  practicalUseGuidance,
  practicalUseGuidanceFilePath,
}) => {
  const navigate = useNavigate();
  const [drugClass, setDrugClass] = useState("");

  useEffect(() => {
    if (!practicalUseGuidanceFilePath) return;
    if (practicalUseGuidance) {
      setDrugClass(practicalUseGuidance);
    } else {
      const titleFromFilename =
        "Practical information on using " +
        extractDrugClassFromFilename(practicalUseGuidanceFilePath);
      setDrugClass(titleFromFilename);
    }
  }, [practicalUseGuidance, practicalUseGuidanceFilePath]);

  const handlePregnancyClick = (e) => {
    e.preventDefault();
    navigate(
      "/viewTopic?etgAccess=true&guidelinePage=quicklinks&topicfile=pbf&guidelinename=auto&sectionId=c_australian_categorisation_of_drugs_in_pregnancy#c_australian_categorisation_of_drugs_in_pregnancy",
    );
  };

  const handleBreastfeedingClick = (e) => {
    e.preventDefault();
    navigate(
      "/viewTopic?etgAccess=true&guidelinePage=quicklinks&topicfile=pbf&guidelinename=auto&sectionId=Classification_of_drug_use_while_breastfeeding_#Classification_of_drug_use_while_breastfeeding_",
    );
  };

  return (
    <div>
      {showCalculator && (
        <div>
          <span className="size-16 bold">Calculators</span>
          <a href="/calculator/idcalc" className={style.calculatorBox}>
            <i
              className={classNames(
                "tg-icons-Calculator size-24",
                style.calculatorIcon,
              )}
            ></i>
            <div>Aminoglycoside initial dose for Adults</div>
          </a>
        </div>
      )}
      <div className={style.pbSection}>
        <span className={classNames("size-16 bold", style.pregnancyTitle)}>
          Pregnancy and breastfeeding
        </span>
        <div className={style.pregnancySection}>
          <div className={style.pregnancyLine} onClick={handlePregnancyClick}>
            <i className="tg-icons-Pregnancy size-24"></i>
            <span dangerouslySetInnerHTML={{ __html: pregnancyInfo }}></span>
          </div>
          <div className="size-12">{pregnancyInfoDescription}</div>
          <div className="size-12">{pregnancyInfoNote}</div>
        </div>
        <div className={style.breastfeedingSection}>
          <div
            className={style.breastfeedingLine}
            onClick={handleBreastfeedingClick}
          >
            <i className="tg-icons-Breastfeeding size-24"></i>
            <span>Breastfeeding compatibility: {breastfeedingCategory}</span>
          </div>
          <div className="size-12">{breastfeedingDescription}</div>
          <div className="size-12">{breastfeedingNote}</div>
        </div>
      </div>
      {renalAdjustmentsHref && (
        <div className={style.kidneySection}>
          <div className={classNames("size-16 bold", style.pregnancyTitle)}>
            Dosage adjustment
          </div>
          <div className={style.kidneyLine}>
            <i className="tg-icons-BloodDrop size-24"></i>
            <div>
              Dosage modification may be required in kidney impairment, see:{" "}
              <a href={renalAdjustmentsHref} className={style.linkText}>
                Antimicrobial dosage modification in kidney impairment
              </a>
            </div>
          </div>
        </div>
      )}

      {practicalUseGuidanceFilePath && (
        <div className={style.practicalUseSection}>
          <div className={classNames("size-16 bold", style.pregnancyTitle)}>
            Other useful information
          </div>
          <div className={style.practicalUseLine}>
            <a
              href={createUrlFromDitaFilename(practicalUseGuidanceFilePath)}
              className={style.linkText}
            >
              {drugClass}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default DrugExtraInformation;
